import { booleanToText } from 'utils/format';
import { Spacer } from '@ontruck/orc';

import FormattedDate from './FormattedDate';
import ChangeRow from './ChangeRow';
import LoadRow from './LoadRow';

import { t_stop } from './constants';

const NewStop = ({ stop }) => {
  return (
    <Spacer mBottom="XS">
      <div>
        <strong>
          {t_stop.stop} {stop?.stop_number}: {t_stop.types[stop?.stop_type] || stop?.stop_type}{' '}
          &mdash; {stop?.company_name}
        </strong>
      </div>

      {Array.isArray(stop?.loads) &&
        stop?.loads?.map((load, key) => <LoadRow load={load} key={key} />)}

      <ChangeRow label={t_stop.city} value={`${stop?.zipcode} - ${stop?.label}`} />

      <ChangeRow
        label={t_stop.times}
        value={
          <FormattedDate
            timeFrom={stop?.time_from}
            timeTo={stop?.time_to}
            tzFrom={stop?.time_from_tz}
            tzTo={stop?.time_to_tz}
          />
        }
      />

      {!!stop?.internal_reference && (
        <ChangeRow label={t_stop.reference} value={stop?.internal_reference} />
      )}
      {!!stop?.instructions && (
        <ChangeRow label={t_stop.instructions} value={booleanToText(stop?.instructions)} />
      )}
      {!!stop?.extra_handling && (
        <ChangeRow label={t_stop.handling} value={booleanToText(stop?.extra_handling)} />
      )}
    </Spacer>
  );
};

export default NewStop;
